/**
 * 模块名称: 公司内部往来款列表=>申请编辑页
 * @author liujingxue@372163.com
 */

import React, { useState, useEffect, useRef } from 'react'
import {
	Select,
	Input,
	Form,
	message,
	Row,
	Col,
	Upload,
	Icon,
} from 'antd'
import api from '@/api'
import BtnGroup from '@/components/BtnGroup'
import { parseSearch, changeMoneyToChinese } from '@/utils'
import { upLoadModule } from '@/utils/common'
import '../assets/style.scss'

const { Option } = Select
const { Dragger } = Upload
const FormItem = Form.Item

const Add = (props) => {
	const { location, history } = props
	const { getFieldDecorator, setFieldsValue, validateFields } = props.form

	const draggerRef = useRef(null)
	const [fileList, setFileList] = useState([])
	const [accountList, setAccountList] = useState([])//获取费用类别
	const [moneyDx, setMoneyDx] = useState('')
	const [rolloff, setRolloff] = useState({})
	const [into, setInto] = useState({})

	const search = parseSearch(location.search)
	
	useEffect(() => {
		//获取公共接口
		api.getInnerFundTransferAccountList({ limit: global.paramsLimit }).then(res => {
			setAccountList(res.list)
		}).catch(err => console.log(err))
		if (search.id) {
			api.getInnerFundTransferDetail({ id: search.id }, true).then(data => {
				const res = data.basic
				const fileLists = res.attachment
				api.getInnerFundTransferAccountList({ limit: global.paramsLimit }).then(data => {
					let obj1 = data.list.filter(v => v.id == res.fromAccountId)[0]
					obj1 && setRolloff(obj1)
					let obj2 = data.list.filter(v => v.id == res.toAccountId)[0]
					obj2 && setInto(obj2)
					setFieldsValue({
						fromAccountId: obj1 ? res.fromAccountId : undefined,
						toAccountId: obj2 ? res.toAccountId : undefined
					})
				}).catch(err => console.log(err))

				setMoneyDx(changeMoneyToChinese(res.money))
				setFieldsValue({
					type: res.type,
					money: res.money,
					remark: res.remark
				})
				if (fileLists.length) {
					fileLists.forEach((item, index) => {
						fileList.push({
							status: 'done',
							uid: index,
							name: item.name,
							url: item.url
						})
					})
					setFileList(fileLists.map((item, index) => ({ ...item, uid: index })))
				}
			})
		}
	}, [])

	//添加
	const handleSubmit = e => {
		e.preventDefault()
		validateFields((err, vals) => {
			let uploadList = []
			for (let i = 0, k = fileList.length; i < k; i++) {
				if (fileList[i].status !== 'removed') {
					uploadList.push({
						url: fileList[i].url,
						name: fileList[i].name
					})
				}
			}
			if (!err) {
				api.setInnerFundTransferApply({
					id: search.id ? search.id : '',
					type: vals.type,
					fromAccountId: vals.fromAccountId,
					toAccountId: vals.toAccountId,
					money: vals.money,
					remark: vals.remark,
					attachment: uploadList
				}).then(res => {
					message.success('保存成功')
					history.push('/corpAccount/InternalAccount')
				})
			} else {
				message.error('请填写必填内容')
			}
		})
	}

	//取消返回列表页
	const onCancel = () => history.push('/corpAccount/InternalAccount')

	// 文件上传 
	const uploadFiles = upLoadModule({
		fileList: fileList,
		setFileList: setFileList,
		draggerRef: draggerRef,
		accept: '.png, .jpg, .PDF, .zip, .xls, .xlsx',
		limitNum: 20
	})

	//费用类别下拉获取具体名称
	const onSelectRolloff = (values) => {
		let obj = accountList.filter(v => v.id == values)[0]
		setRolloff(obj)
	}

	//
	const onSelectInto = (values) => {
		let obj = accountList.filter(v => v.id == values)[0]
		setInto(obj)
	}

	//付款金额
	const onChangeMoney = (e) => {
		if (e.target.value) {
			setMoneyDx(changeMoneyToChinese(e.target.value))
		} else {
			setMoneyDx('')
		}
	}

	const formItemLayout = {
		labelCol: {
			xs: { span: 24 },
			sm: { span: 8 },
		},
		wrapperCol: {
			xs: { span: 24 },
			sm: { span: 16 },
		},
	}

	return (
		<>
			<div className="cost-management-apply">
				<h1 className="cost-management-apply-title">{search.id ? '转款驳回重提申请' : '转款申请'}</h1>
				<div className="line"></div>
				<Form onSubmit={handleSubmit} {...formItemLayout}>
					<h3 className="cost-management-apply-tit">基本信息</h3>
					<Row gutter={24}>
						<Col span={6}>
							<FormItem label="转款类型">
								{getFieldDecorator('type', {
									rules: [{ required: true, message: '请选择' }]
								})(<Select
									placeholder="请选择"
									showSearch={true}
									optionFilterProp="children"
									dropdownMatchSelectWidth={false}
								>
									<Option value={1}>募投账户转款</Option>
									<Option value={2}>研发账户转款</Option>
									<Option value={3}>银行转账</Option>
								</Select>)}
							</FormItem>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={6}>
							<FormItem label="转出账户">
								{getFieldDecorator('fromAccountId', {
									rules: [{ required: true, message: '请选择' }]
								})(<Select 
									placeholder="请选择" 
									dropdownMatchSelectWidth={false} 
									onSelect={onSelectRolloff}
									optionFilterProp="children"
									showSearch={true}
								>
									{
										accountList.map((v, i) => {
											return <Option value={v.id} key={i}>{v.accountName}</Option>
										})
									}
								</Select>)}
							</FormItem>
						</Col>
						<Col span={6}>
							<FormItem label="转出账户主体"><div>{rolloff.corpName}</div></FormItem>
						</Col>
						<Col span={6}>
							<FormItem label="账号"><div>{rolloff.accountNo}</div></FormItem>
						</Col>
						<Col span={6}>
							<FormItem label="开户行"><div>{rolloff.bank}</div></FormItem>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={6}>
							<FormItem label="转入账户">
								{getFieldDecorator('toAccountId', {
									rules: [{ required: true, message: '请选择' }]
								})(<Select 
									placeholder="请选择" 
									dropdownMatchSelectWidth={false} 
									onSelect={onSelectInto}
									optionFilterProp="children"
									showSearch={true}
								>
									{
										accountList.map((v, i) => {
											return <Option value={v.id} key={i}>{v.accountName}</Option>
										})
									}
								</Select>)}
							</FormItem>
						</Col>
						<Col span={6}>
							<FormItem label="转入账户主体"><div>{into.corpName}</div></FormItem>
						</Col>
						<Col span={6}>
							<FormItem label="账号"><div>{into.accountNo}</div></FormItem>
						</Col>
						<Col span={6}>
							<FormItem label="开户行"><div>{into.bank}</div></FormItem>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={6}>
							<FormItem label="转款金额">
								{getFieldDecorator('money', {
									rules: [{ required: true, message: '请输入' }, {
										pattern: /(^-?[0-9]*(\.[0-9]{1,2})?%?$)|(^0%?$)|(^-?[0-9]\.[0-9]([0-9])?%?$)/, message: '请输入正确的格式'
										// /^-?[0-9]*(\.[0-9]*)?$/
									}]
								})(<Input placeholder="请输入" onChange={onChangeMoney} />)}
							</FormItem>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={6}>
							<FormItem label={<span style={{ color: 'red' }}>大写金额</span>}>
								{moneyDx && <div style={{ color: 'red' }}>{moneyDx}</div>}
							</FormItem>
						</Col>
					</Row>
					<h3 className="cost-management-apply-tit">其他信息</h3>

					<div style={{ marginTop: 20 }}>
						<FormItem label="附件" labelCol={{ span: 2 }}>
							<div className="dragger-box" ref={draggerRef}>
								<Dragger
									{...uploadFiles}
								>
									<p className="ant-upload-drag-icon">
										<Icon type="inbox" />
									</p>
									<p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
									<p className="ant-upload-hint">
										附件支持格式：xls、xlsx、PNG、JPG、PDF、zip 支持添加多个附件，单个附件大小不超过5M，文件数量不超过20个。
									</p>
								</Dragger>
							</div>
						</FormItem>
					</div>
					<div style={{ marginTop: 20 }}>
						<FormItem label="备注" labelCol={{ span: 2 }}>
							{getFieldDecorator('remark')(
								<Input.TextArea maxLength={100} />
							)}
						</FormItem>
					</div>
					<BtnGroup confirmName="提交" onCancel={onCancel} />
				</Form>
			</div>
		</>
	)
}

export default Form.create()(Add)